// chart.js and recharts draw on canvas/SVG and cannot read Tailwind dark: classes,
// so the actual hex values live here, following the same tokens as tailwind.config.js.
import { Chart as ChartJS } from "chart.js";

// Same font as the rest of the app (otherwise canvas falls back to the default system font).
ChartJS.defaults.font.family = 'Geist, ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';
ChartJS.defaults.font.size = 11;

export function getChartColors(darkMode) {
  return {
    text: darkMode ? "#8995A7" : "#516073", // slate-400 / slate-500
    textStrong: darkMode ? "#E9EDF2" : "#222B38",
    grid: darkMode ? "#222B38" : "#CCD4DF", // slate-800 / slate-200
    tooltipBg: darkMode ? "#1A212B" : "#F1F4F8",
    tooltipBorder: darkMode ? "#2A3340" : "#B4BFCE",
    surface: darkMode ? "#151B24" : "#F1F4F8", // border of the donut slices, to blend with the panel
    accent: darkMode ? "#5AAAE0" : "#1E6FAE", // the only accent (from the logo)
    muted: darkMode ? "#5F6C7F" : "#A3AEBE", // second series, neutral
  };
}

// Palette for multi-category charts (data, not decoration): accent + muted tones.
export const CHART_PALETTE = ["#1E6FAE", "#2A9D75", "#D69A2D", "#D4504C", "#7C8DA6", "#4FB3C8"];

export const COLOR_PRIMARY = "#1E6FAE";
export const COLOR_TEAL = "#2A9D91";
export const COLOR_SUCCESS = "#2A9D75";
export const COLOR_DANGER = "#D4504C";
export const COLOR_WARNING = "#D69A2D";
export const COLOR_PURPLE = "#7C8DA6";

// Consistent number formatting across all charts (1250.5 -> "1.250,50")
export function formatNumber(value, decimals = 0) {
  const num = Number(value) || 0;
  return num.toLocaleString("sr-RS", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

// Shared tooltip look for all chart.js charts
export function tooltipStyle(colors) {
  return {
    backgroundColor: colors.tooltipBg,
    borderColor: colors.tooltipBorder,
    borderWidth: 1,
    titleColor: colors.textStrong,
    bodyColor: colors.textStrong,
    padding: 10,
    cornerRadius: 8,
    boxPadding: 4,
    usePointStyle: true,
  };
}
